import { Controller } from "@hotwired/stimulus"

const actionTriggerSelector = "[data-next-action-target-id-param]"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll(actionTriggerSelector).forEach(trigger => {
      trigger.addEventListener("click", this.visit)
    })
  }

  disconnect() {
    this.element.querySelectorAll(actionTriggerSelector).forEach(trigger => {
      trigger.removeEventListener("click", this.visit)
    })
  }

  visit(event) {
    visitInvoiceActionTarget(event, event.currentTarget)
  }
}

function visitInvoiceActionTarget(event, trigger) {
  const targetId = trigger.dataset.nextActionTargetIdParam || targetIdFromLink(trigger)
  const target = document.getElementById(targetId)

  if (!target) return

  event.preventDefault()
  revealTarget(targetId)

  requestAnimationFrame(() => {
    target.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
    window.history.replaceState(null, "", `#${targetId}`)
    highlight(target)
  })
}

function targetIdFromLink(link) {
  const href = link.getAttribute("href")
  if (!href?.startsWith("#")) return null

  return href.slice(1)
}

function revealTarget(targetId) {
  if (targetId === "line_items_section") {
    document.querySelector("[data-lines-tabs-target='lineItemsTab']")?.click()
  }

  if (targetId === "vat_lines_section") {
    document.querySelector("[data-lines-tabs-target='vatTab']")?.click()
  }
}

function highlight(target) {
  document.querySelectorAll(".invoice-action-target-highlight").forEach(element => {
    element.classList.remove("invoice-action-target-highlight")
  })

  target.classList.add("invoice-action-target-highlight")

  window.setTimeout(() => {
    target.classList.remove("invoice-action-target-highlight")
  }, 6000)
}
